export function formatNum(n) {
  if (n == null || Number.isNaN(Number(n))) return '—';
  return Number(n).toLocaleString();
}

export function formatTrend(delta, label = 'new users') {
  if (delta == null || delta === 0) return null;
  const sign = delta > 0 ? '+' : '';
  return `${sign}${delta}% ${label} vs prior week`;
}

export function statusBadgeClass(status) {
  if (status === 'needs_review') return 'badge-review';
  if (status === 'sent') return 'badge-sent';
  if (status === 'scheduled') return 'badge-scheduled';
  return 'badge-draft';
}

export function formatSentAt(sentAt) {
  if (!sentAt) return '—';
  return new Date(sentAt).toLocaleString();
}
